import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

let router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home'),
      },
    {
      path: '/dashboard',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          alias: '/dashboard/index',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          path: '/terms',
          name: 'terms',
          component: () => import(/* webpackChunkName: "account" */ './views/Tc.vue')
        },
        {
          path: '/privacy',
          name: 'privacy',
          component: () => import(/* webpackChunkName: "account" */ './views/Privacy.vue')
        },
        // Pages
        {
          name: 'User Profile',
          path: 'pages/user',
          component: () => import('@/views/dashboard/pages/UserProfile'),
        },
        {
          name: 'Timeline',
          path: 'pages/timeline',
          component: () => import('@/views/dashboard/pages/Timeline'),
        },
        {
          name: 'Notifications',
          path: 'components/notifications',
          component: () => import('@/views/dashboard/component/Notifications'),
        },
        {
          name: 'Icons',
          path: 'components/icons',
          component: () => import('@/views/dashboard/component/Icons'),
        },
        {
          name: 'Typography',
          path: 'components/typography',
          component: () => import('@/views/dashboard/component/Typography'),
        },
        // Diary
        {
          name: 'Weight Diary',
          path: 'pages/weight-diary',
          component: () => import('@/views/dashboard/pages/WeightDiary'),
        },
        {
          name: 'Food Diary',
          path: 'pages/food-diary',
          component: () => import('@/views/dashboard/pages/FoodDiary'),
        },
        {
          name: 'Add Food',
          path: 'pages/food-diary/add',
          component: () => import('@/views/dashboard/pages/FoodAdd'),
        },
        {
          name: 'Subscription',
          path: 'pages/subscription',
          component: () => import('@/views/dashboard/pages/Subscription'),
        },
        {
          name: 'New Subscription',
          path: 'pages/new-subscription',
          component: () => import('@/views/dashboard/pages/NewSubscription'),
        },

        
        // Maps
        {
          name: 'Google Maps',
          path: 'maps/google-maps',
          component: () => import('@/views/dashboard/maps/GoogleMaps'),
        },
        // Upgrade
        {
          name: 'Upgrade',
          path: 'upgrade',
          component: () => import('@/views/dashboard/Upgrade'),
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  // Wait for the profile to load
  if (to.name != 'Home' && !store.state.Profile.profile) {//User.user) {
    store.commit('Ui/pageLoading', true);
    store.watch(
      (state)=>{
        return state.Profile.profile
      },
      (newValue)=>{
        if (newValue) {
          store.commit('Ui/pageLoading', false);
          next()
        }
      }
    )
  } else {
    next();
  }
})

export default router;